module.exports = __webpack_public_path__ + "static/img/loader.17dc146.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loader.gif
// module id = x4IX
// module chunks = 1